export const VALIDATION = {
    CARD_NUMBER_LENGTH: 19,
    CARD_EXPIRATION_DATE_LENGTH: 7,
    CARD_CVV_MIN_LENGTH: 3,
    CARD_CVV_MAX_LENGTH: 4,
}